/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {bus} from '@/main';
import commonSocketRef from "@/videoNotificationSocket";
import loader from '@/components/common/component-small-loader';
import pdfViewer from './pdf-viewer';
import recreatingPrescriptionPopup from "../recreating-pre-view-popup";
import toast from '@/services/toast';

export default {
  name: 'pre-of-patient',
  components: {
    'pdf-viewer' : pdfViewer,
    loader,
    'recreating-prescription-popup' : recreatingPrescriptionPopup
  },
  props: ['preOfPateintId', 'preOfAppointmentId'],
  data () {
    return {
      addPrescriptionPopup:false,
      prescriptionData:{
        drug:'',
        route:'',
        direction:'After Meals',
        frequency:[],
        duration:'',
        quantity:'',
        dose:'',
        strength:'',
        duration_unit:'Days',
        dose_unit:'Ml',
        strength_unit:'Mg',
        frequency_others:'',
        special_instruction:'',
        prescriptionID:''
      },
      frequencyOthersKeyRequired:false,
      prescriptionName:'',
      submitted:false,
      prescriptionDetailsData:[],
      otherFrequencyFlag:false,
      preCreationDone:true,
      preCreationSpclInstructionDone:false,
      prescriptionList:'',
      prescriptionListResult:[],
      pdfViewerPopup:false,
      pdfViewerFileName:'',
      pdfViewerUrl:'',
      prescriptionInfoByIdPopup:false,
      prescriptionInfoByIdData:null,
      prescriptionNumber : ['', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth','Tenth', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen','twenty'],
      recreatingPrescData:null,
      recreatingPrescDataPopupState:false
    }
  },
  computed: {

  },
  mounted () {
    this.getPrescriptionListAgainFun()
    bus.$on('pdfViewerPopupBus', (data) => {
      this.pdfViewerPopup = data;
    });
    bus.$on('recreatingPrescDataPopupStateBus', (data) => {
      this.recreatingPrescDataPopupState = data;
      this.getPrescriptionListAgainFun()
    });
  },
  methods: {
    recreatingPrescDataPopupOpen(data){
      this.recreatingPrescData = data
      this.recreatingPrescDataPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    frequencyOthersFun(){
      if(this.frequencyOthersKeyRequired == false){
        this.frequencyOthersKeyRequired = true
        this.prescriptionData.frequency = []
        this.prescriptionData.frequency_others = 'if required'
      }else{
        this.frequencyOthersKeyRequired = false
        this.prescriptionData.frequency_others = ''
      }
    },
    getPrescriptionListAgainFun(){
      this.$store.dispatch('getPrescriptionListOfPatientMethod', {id:this.preOfAppointmentId}).then((res)=>{
        this.prescriptionList = res.data.data
        if(this.prescriptionList){
          this.prescriptionListResult = this.prescriptionList.results
          this.prescriptionName = this.prescriptionNumber[this.prescriptionListResult.length + parseInt(1)]
        }
      })
    },
    addPrescriptionPopupMethod(){
      this.addPrescriptionPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    createPrescriptionBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var record = {}
          record.drug = this.prescriptionData.drug
          record.route = this.prescriptionData.route
          record.direction = this.prescriptionData.direction
          record.frequency = JSON.stringify(this.prescriptionData.frequency)
          record.quantity = this.prescriptionData.quantity
          record.duration = this.prescriptionData.duration + ' ' + this.prescriptionData.duration_unit  
          record.dose = this.prescriptionData.dose + ' ' + this.prescriptionData.dose_unit  
          record.strength = this.prescriptionData.strength + ' ' + this.prescriptionData.strength_unit 
          record.frequency_others = this.prescriptionData.frequency_others
          this.prescriptionDetailsData.push(record)
          this.submitted =  false
          setTimeout(() => {
            this.prescriptionData.drug = ''
            this.prescriptionData.route = ''
            this.prescriptionData.direction = 'After Meals'
            this.prescriptionData.frequency = []
            this.prescriptionData.duration = ''
            this.prescriptionData.quantity = ''
            this.prescriptionData.dose = ''
            this.prescriptionData.strength = ''
            this.prescriptionData.duration_unit = 'Days'
            this.prescriptionData.dose_unit = 'Ml'
            this.prescriptionData.strength_unit = 'Mg'
            this.prescriptionData.frequency_others = ''
            this.frequencyOthersKeyRequired = false
            this.$validator.reset()
          }, 400)
          return;
        }
      })
    },    
    removPrescriptionDetailsOnList(index){
      this.prescriptionDetailsData.splice(index, 1)
    },
    submitPrescriptionBeforeSubmitMethod(){
      this.submitted =  true
      let data = {
        patient_id:this.preOfPateintId,
        appointment_id:this.preOfAppointmentId,
        prescription_details :this.prescriptionDetailsData
      }
      this.$store.dispatch('createPrescriptionOfPatientMethod', data)
        .then((res) => {  
          this.prescriptionData.prescriptionID = res.data.data.id
          let notificationPayload = { 
            type:'patient_prescription',
            data_id:this.prescriptionData.prescriptionID,
            message:'patient prescription has benn created'
          }
          this.$store.dispatch('postNotificationFunc', notificationPayload)
          this.submitted =  false
          this.preCreationDone = false
          this.preCreationSpclInstructionDone = true
          this.getPrescriptionListAgainFun()
          commonSocketRef.emit({
            message: `Prescription Data`,
            type: "patient_prescription",
            patient_id:this.preOfPateintId,
            appointment_id:this.preOfAppointmentId,
          });
          toast.success(res.data.msg);
        }).catch((err) => {
          this.submitted =  false
          toast.error(err.data.user_msg || err.data.msg);
        })
      return;
    },
    spclInstructionUpdateMethod(){
      if(this.prescriptionData.special_instruction){
        this.submitted =  true
        let data = {
          special_instruction : this.prescriptionData.special_instruction
        }
        this.$store.dispatch('updatePrescriptionDataOfPatientMethod', {data:{data:data,id:this.prescriptionData.prescriptionID}}).then((res) => {
          this.submitted =  false
          this.preCreationSpclInstructionDone = false
          this.getPrescriptionListAgainFun()
        })
      }else{
        this.preCreationSpclInstructionDone = false
      }
    },
    closePrescriptionPopupMethod(){
      this.prescriptionDetailsData = []
      this.prescriptionData.drug = ''
      this.prescriptionData.route = ''
      this.prescriptionData.direction = 'After Meals'
      this.prescriptionData.frequency = []
      this.prescriptionData.duration = ''
      this.prescriptionData.quantity = ''
      this.prescriptionData.dose = ''
      this.prescriptionData.strength = ''
      this.prescriptionData.duration_unit = 'Days'
      this.prescriptionData.dose_unit = 'Ml'
      this.prescriptionData.strength_unit = 'Mg'
      this.prescriptionData.frequency_others = ''
      this.prescriptionData.special_instruction = ''
      this.preCreationDone = true
      this.preCreationSpclInstructionDone = false
      this.addPrescriptionPopup = false
      this.frequencyOthersKeyRequired = false
      $('body').removeClass('body_right_scroll_remove')
    },
    pdfViewerFun(url){
      var getName = url.split("?")[0].split("/")
      const fileName = getName[getName.length - 1]
      this.pdfViewerFileName = fileName
      this.pdfViewerUrl = url
      this.pdfViewerPopup = true
      $('body').addClass("pdf_view_actv")
    },
    prescriptionInfoByIdPopupFun(data){
      this.prescriptionInfoByIdData = data
      this.prescriptionInfoByIdPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closePrescriptionInfoPopupMethod(){
      this.prescriptionInfoByIdData = null
      this.prescriptionInfoByIdPopup = false
      $('body').removeClass('body_right_scroll_remove')
    }
  }
}